import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { ButtonDecorator } from '../../components/ButtonDecorator/ButtonDecorator';
import { ModalDecorator } from '../../components/ModalDecorator/ModalDecorator';
import { Bem } from '../../service/Bem/Bem';
import { CanvasPcodeVideoFrameParams } from '../../service/Pcode/PcodeCanvasVideo';
import { PcodeVideoCanvasPreview } from '../PcodeVideoCanvasPreview/PcodeVideoCanvasPreview';

import './VideoAdditionPreviewModal.css';
import * as keyset from './VideoAdditionPreviewModal.i18n';

const i18n = i18nFactory(keyset);

export interface VideoAdditionPreviewModalProps {
    creativeName: string;
    videoPreviewData?: Partial<CanvasPcodeVideoFrameParams>;
    isVisible: boolean;
    onClose: () => void;
    onSave: () => void;
    onAdEndCallback?: () => void;
    isAudio: boolean;
}

const BLOCK = 'video-addition-preview-modal';

export class VideoAdditionPreviewModal extends React.PureComponent<
    VideoAdditionPreviewModalProps,
    {
        previewReady: boolean;
    }
> {
    static BottomControls = React.memo(
        ({ onSave, onClose }: Pick<VideoAdditionPreviewModalProps, 'onClose' | 'onSave'>) => (
            <>
                <ButtonDecorator
                    cls={Bem.cls(BLOCK, 'add-button')}
                    size="n"
                    text={i18n('add')}
                    theme="action"
                    view="classic"
                    onClick={onSave}
                />
                <ButtonDecorator
                    cls={Bem.cls(BLOCK, 'cancel-button')}
                    size="n"
                    text={i18n('cancel')}
                    theme="normal"
                    view="classic"
                    onClick={onClose}
                />
            </>
        )
    );

    state = {
        previewReady: false
    };

    private previewVideoRef: PcodeVideoCanvasPreview;

    componentDidUpdate(prevProps: Readonly<VideoAdditionPreviewModalProps>): void {
        const { videoPreviewData } = this.props;

        if (videoPreviewData && this.state.previewReady) {
            this.previewVideoRef.onExternalInitPlayer(videoPreviewData);
        }
    }

    render(): React.ReactNode {
        const {
            isVisible,
            creativeName,
            isAudio,
            onAdEndCallback = () => {
                return;
            }
        } = this.props;

        return (
            <ModalDecorator
                header={i18n('title', {
                    creativeName
                })}
                footer={this.renderFooter()}
                onOutsideClick={this.onClose}
                visible={isVisible}
                cls={BLOCK}
                bodyCls={Bem.cls(BLOCK, 'content-wrapper')}
            >
                <PcodeVideoCanvasPreview
                    videoCls={Bem.cls(BLOCK, 'video')}
                    onAdEndCallback={onAdEndCallback}
                    isAudio={isAudio}
                    ref={this.setPreviewVideoRef}
                />
            </ModalDecorator>
        );
    }

    public onClose = (): void => {
        this.props.onClose();
    };

    private setPreviewVideoRef = (el: PcodeVideoCanvasPreview) => {
        this.previewVideoRef = el;
        this.setState({
            previewReady: !!this.previewVideoRef
        });
    };

    private renderFooter = (): React.ReactNode => {
        const { onSave } = this.props;

        return <VideoAdditionPreviewModal.BottomControls onSave={onSave} onClose={this.onClose} />;
    };
}
